import { useEffect, useState } from 'react';
import { ChevronDown, Clock } from 'lucide-react';
import { api, AuditLog } from '@/services/api';
import { formatSafe } from '@/lib/utils';

export function LeadAuditLogPanel({ leadId, scope }: { leadId: string; scope: string }) {
  const [open, setOpen] = useState(false);
  const [retry, setRetry] = useState(0);
  const [state, setState] = useState<{ scope: string; loading: boolean; error: boolean; items: AuditLog[]; truncated: boolean }>({ scope: '', loading: false, error: false, items: [], truncated: false });
  const key = JSON.stringify([leadId, scope]);
  useEffect(() => {
    let active = true;
    setState({ scope: key, loading: open, error: false, items: [], truncated: false });
    if (open) {
      api.getAuditLogs(leadId).then(data => {
        if (active) setState({ scope: key, loading: false, error: false, items: data.items, truncated: data.truncated });
      }).catch(() => {
        if (active) setState({ scope: key, loading: false, error: true, items: [], truncated: false });
      });
    }
    return () => { active = false; };
  }, [open, key, retry]);
  const loading = state.scope !== key || state.loading;
  return (
    <div className="bg-white dark:bg-[#1A1D21] border border-gray-200/80 dark:border-gray-800 rounded-2xl shadow-2xs overflow-hidden">
      <button type="button" aria-expanded={open} onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4 text-left text-xs font-bold text-gray-700 dark:text-gray-300">
        <span className="flex items-center gap-2"><Clock className="w-4 h-4" />Logs de Auditoria</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <div className="p-4 pt-2 space-y-2.5 border-t border-gray-100 dark:border-gray-800/60">
        {loading ? <p role="status" className="text-xs text-gray-500">Carregando histórico…</p> : state.error ? (
          <div role="alert" className="text-xs text-gray-600 dark:text-gray-300">
            <p>Histórico indisponível. Tente novamente.</p>
            <button type="button" onClick={() => setRetry(n => n + 1)} className="mt-2 text-blue-600 underline">Tentar novamente</button>
          </div>
        ) : state.items.length ? state.items.map(log => (
          <div key={log.id} className="text-[11px] pb-2 border-b border-gray-100 dark:border-gray-800/50 last:border-0">
            <p className="font-bold text-gray-800 dark:text-gray-200">{log.acao}</p>
            <p className="text-gray-500">{log.created_at ? formatSafe(log.created_at, 'HH:mm - dd/MM/yy') : 'Horário não registrado'}</p>
          </div>
        )) : <p className="text-xs text-gray-500 italic">Nenhum log encontrado.</p>}
        {!loading && !state.error && state.truncated && <p className="text-xs text-gray-500">Histórico parcial: limite de registros recentes por fonte atingido.</p>}
      </div>}
    </div>
  );
}
